import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['links', 'template', 'range', 'tplAddRangeBtn'];

  connect() {
    this._showHideTimeRangHeader();
  }

  addAssociation(e) {
    e.preventDefault();

    const weekday = e.currentTarget.dataset.weekday;
    const content = this.templateTarget.innerHTML
            .replace(/NEW_RECORD/g, new Date().getTime())
            .replaceAll(/Sunday/g, weekday.charAt(0).toUpperCase() + weekday.slice(1))
            .replaceAll(/sunday/g, weekday);

    const lines = [...this.rangeTargets].filter(range => range.dataset.weekday === weekday);
    lines.pop().insertAdjacentHTML('afterend', content);

    e.currentTarget.remove();
    this._showHideTimeRangHeader(weekday);
    this._toggleH24(weekday);
  }

  removeAssociation(e) {
    e.preventDefault();

    const wrapper = e.target.closest('.time-inputs');
    const weekday = wrapper.dataset.weekday;
    const isNewRecord = wrapper.dataset.newRecord === 'true';

    if (isNewRecord) wrapper.remove();
    else {
      wrapper.parentNode.querySelector('.hidden-field').value = 1;
      wrapper.classList.add('d-none');
    }

    this._toggleCloseButtons(weekday);
  }

  _toggleH24(weekday) {
    const timeInputs = this._getRowsInputs(weekday).filter((item) => item);
    const visibleRowInputs = timeInputs.filter((item) => !item.classList.contains('d-none'));
    const dayRanges = [...this.rangeTarget.parentNode.querySelectorAll('.time-range-row')]
                      .filter((item) => item.dataset.weekday === weekday);

    const h24 = [...dayRanges].find((item) => item.querySelectorAll('.h24'))
                              .querySelector('.h24 input');

    const checkNeeded = !h24.checked && visibleRowInputs.length === 1;
    const uncheckNeeded = h24.checked && visibleRowInputs.length > 1;

    if (visibleRowInputs.length === 1) this._fillTimesValue(visibleRowInputs);

    if (checkNeeded) {
      const scheduleController = this.application.getControllerForElementAndIdentifier(
        this.rangeTarget, 'bo-schedule-time-range');

      scheduleController._toggleVisibilityTimepickers(weekday, true, this.element);

      h24.checked = 'checked';
    };

    if (uncheckNeeded) {
      h24.checked = '';
      this._fillTimesValue(visibleRowInputs);
    };
  }

  _showHideTimeRangHeader(weekday) {
    let lastDay = 'firstOneIsFalse';

    this._getRowsToLoopOn(weekday).forEach((row) => {
      if (lastDay === row.dataset.weekday) {
        row.classList.remove('d-none');
        row.querySelector('.header-row')?.classList.add('d-none');
        row.querySelector('.time-inputs')?.classList.remove('d-none');
        row.querySelector('.fa-xmark')?.classList.remove('d-none');
      }

      weekday && this._toggleCloseButtons(weekday);
      const fromConnect = !weekday;
      this._showOnlyOnePlusButtonOnRow(row.dataset.weekday, fromConnect);
      this._setHeaderIndexes(row.dataset.weekday);

      lastDay = row.dataset.weekday;
    });
  }

  _setHeaderIndexes(weekday) {
    this._getRowsToLoopOn(weekday).forEach((item, index) => item.dataset.index = index);
  }

  _toggleCloseButtons(weekday) {
    const timeInputs = this._getRowsInputs(weekday).filter((item) => item);
    const visibleRowInputs = timeInputs.filter((item) => !item.classList.contains('d-none'));

    if (visibleRowInputs.length > 1) {
      visibleRowInputs.forEach((item) => item.querySelector('.fa-xmark').classList.remove('d-none'));
    } else {
      visibleRowInputs[0].querySelector('.fa-xmark').classList.add('d-none');
    }

    this._setDefaultTimesValue(weekday);
  }

  _showOnlyOnePlusButtonOnRow(weekday, fromConnect) {
    const rangeRow = this._getRowsToLoopOn(weekday).pop();
    const addRangeBtn = this.tplAddRangeBtnTarget.innerHTML.replace(/NEW_BTN/g, weekday);
    rangeRow.querySelector('.add-range-container').innerHTML = addRangeBtn;
    const openStatus = rangeRow.querySelector('.add-range-container').dataset.openStatus !== 'true';
    const h24 = rangeRow.querySelector('.h24 input').checked;

    rangeRow.querySelector('.add-range-container .btn').classList.toggle('d-none', fromConnect && (openStatus || h24));
  }

  _getRowsToLoopOn(weekday) {
    const timeRows = [...this.element.querySelectorAll('.time-range-row')];
    return weekday ? timeRows.filter((row) => row.dataset.weekday === weekday) : timeRows;
  }

  _getRowsInputs(weekday) {
    return [...this._getRowsToLoopOn(weekday)].map((item) => {
      return item.querySelector('.time-inputs');
    });
  }

  _setDefaultTimesValue(weekday) {
    const timeInputs = this._getRowsInputs(weekday).filter((item) => item);
    const visibleRowInputs = timeInputs.filter((item) => !item.classList.contains('d-none'));

    const anyValue = visibleRowInputs.some((item) => {
      return [...item.querySelectorAll('input')].some((item)=> item.value);
    });

    if (!anyValue) this._fillTimesValue(visibleRowInputs);
  }

  _fillTimesValue(visibleRowInputs) {
    const inputs = visibleRowInputs[0].querySelectorAll('.input');

    const defaultBeginTime = '09:00';
    const defaultEndTime = '18:00';

    inputs.forEach((item, i) => {
      const hiddenFlatpickerInputs = item.parentNode.querySelectorAll('.flatpickr-input');
      item.value = i === 0 ? defaultBeginTime : defaultEndTime;
      hiddenFlatpickerInputs[i].value = i === 0 ? defaultBeginTime : defaultEndTime;
    });
  }
}
